import { customReservedInventoryBucketTypeIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod/v4";

export const deleteCustomReservedInventoryBucketType = {
  name: "deleteCustomReservedInventoryBucketType" as const,
  input: z.object({ id: customReservedInventoryBucketTypeIdFormat.schema }),
  output: z.object({ success: z.boolean() }),
};
